// extracted by mini-css-extract-plugin
export default {"container":"container__923e7a15","normal":"normal__923e7a15","bold":"bold__923e7a15","active":"active__923e7a15"};